import axios from 'axios';
import { i18n } from 'next-i18next';

const baseUrlApi = process.env.NEXT_PUBLIC_API_URL ?? '';

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: baseUrlApi,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Forward the locale the user selected on the site as Accept-Language, so the API can
// send localized transactional emails (e.g. squad invites) in that language. The site
// only switches the locale client-side via next-i18next — it is never persisted on the
// account — so without this header the API sees the browser default and falls back to
// the account's country. SCRUM-1646.
axiosInstance.interceptors.request.use((config) => {
  const locale = i18n?.language;
  if (locale) {
    config.headers.set('Accept-Language', locale);
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
